const navs = [
  { id: 1, type: "text", name: "Beranda", link: "/" },
  { id: 2, type: "text", name: "Kategori", link: "/categories" },
];

export default navs;
